/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

export type BitrateStateType = 'Keep' | 'Reset';
export type BitrateModeType = 'Normal' | 'Force' | 'Reset';

export enum BitrateState {
  Keep,
  Reset
}

export enum BitrateMode {
  Normal,
  Force,
  Reset
}

export interface ISetTemporaryMaximalBitrate {
  apiVersion: number;
  sharedSecret: string;
  elapsedInMilliseconds: number;
  bitrateInBitsPerSecond: number;
  bitrateState: BitrateStateType;
  bitrateMode: BitrateModeType;
}